import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { crearOEditarEntidadSalud } from "../../services/entidades-salud-service";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import { obtenerParametrosPorTipos } from '../../../Parametros/services/parametros-service';

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const YES_OR_NO_OPTIONS = [
    { label: "SI", value: 1 },
    { label: "NO", value: 0 },
];

const FormEntidadesSalud = ({ modalState, onSaved }) => {
    const { entidadSalud } = modalState.data;
    const [tiposEntidades, setTiposEntidades] = useState([]);
    const [tiposRegimen, setTiposRegimen] = useState([]);

    const vistaEventos = {
        label: entidadSalud.vistaEventos == 1 ? "SI" : "NO",
        value: entidadSalud.vistaEventos == 1 ? 1 : 0,
    };

    const vistaEmpleados = {
        label: entidadSalud.vistaEmpleados == 1 ? "SI" : "NO",
        value: entidadSalud.vistaEmpleados == 1 ? 1 : 0,
    };

    const defaultValues = {
        id: entidadSalud.id || "",
        nit: entidadSalud.nit || "",
        nombre: entidadSalud.nombre || "",
        vistaEventos: vistaEventos,
        vistaEmpleados: vistaEmpleados,
        filtrosEntidadSalud: entidadSalud.filtrosEntidadSalud || "",
        parametro_tipo_entidad: entidadSalud.parametro_tipo_entidad
            ? {
                  label: entidadSalud.tipo_entidad,
                  value: entidadSalud.parametro_tipo_entidad,
              }
            : "",
        parametro_regimen_entidad: entidadSalud.parametro_regimen_entidad
            ? {
                  label: entidadSalud.regimen_entidad,
                  value: entidadSalud.parametro_regimen_entidad,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [entidadSalud]);

    const onCreateEntidadSalud = async (entidadSalud) => {
        const resp = await crearOEditarEntidadSalud({
            ...entidadSalud,
            vistaEventos: entidadSalud.vistaEventos.value,
            vistaEmpleados: entidadSalud.vistaEmpleados.value,
            parametro_tipo_entidad: entidadSalud.parametro_tipo_entidad.value,
            parametro_regimen_entidad:
                entidadSalud.parametro_regimen_entidad.value,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSaved();
    };

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos("entidad_salud");
        if (!resp.status) return toast.error(resp.message);

        const tiposEntidades = resp.data.map((tipoEntidad) => {
            return {
                value: tipoEntidad.id,
                label: tipoEntidad.nombre,
            };
        });

        setTiposEntidades(tiposEntidades);
    }, []);

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos("regimen_salud");
        if (!resp.status) return toast.error(resp.message);

        const tiposRegimen = resp.data.map((tipoRegimen) => {
            return {
                value: tipoRegimen.id,
                label: tipoRegimen.nombre,
            };
        });

        setTiposRegimen(tiposRegimen);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formEntidadSalud"
            onSubmit={onCreateEntidadSalud}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre tipo parametro"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Nit"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nit"
                        rules={REQUIRED_RULE}
                        placeholder="Nit"
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Tipo de Entidad"
                        options={tiposEntidades}
                        errors={form.formState.errors}
                        control={form.control}
                        name="parametro_tipo_entidad"
                        rules={REQUIRED_RULE}
                        placeholder="Tipo Entidad"
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Regimen de la Entidad"
                        options={tiposRegimen}
                        errors={form.formState.errors}
                        control={form.control}
                        name="parametro_regimen_entidad"
                        rules={REQUIRED_RULE}
                        placeholder="Regimen de la Entidad"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Filtro Entidad de Salud"
                        errors={form.formState.errors}
                        control={form.control}
                        name="filtrosEntidadSalud"
                        placeholder="Filtro Entidad de Salud"
                    />
                </Col>
                <Col sm={3}>
                    <SelectController
                        label="Vista en Empleados"
                        errors={form.formState.errors}
                        control={form.control}
                        name="vistaEmpleados"
                        rules={REQUIRED_RULE}
                        options={YES_OR_NO_OPTIONS}
                    />
                </Col>
                <Col sm={3}>
                    <SelectController
                        label="Vista en Eventos"
                        errors={form.formState.errors}
                        control={form.control}
                        name="vistaEventos"
                        rules={REQUIRED_RULE}
                        options={YES_OR_NO_OPTIONS}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormEntidadesSalud.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func,
}

export default FormEntidadesSalud;
